import React from "react";
import { passwordRules } from "./passwordSchema";

// Shows only the password rules that are currently BROKEN, in red. Each rule
// disappears from the list as soon as it passes. Nothing renders until the
// user has started typing.
const PasswordRequirements = ({ value }) => {
  if (!value) return null;

  const failing = passwordRules.filter((rule) => !rule.test(value));
  if (failing.length === 0) return null;

  return (
    <ul className="uk-list uk-text-small uk-text-danger uk-margin-small-top uk-margin-remove-bottom">
      {failing.map((rule) => (
        <li key={rule.id}>{rule.label}</li>
      ))}
    </ul>
  );
};

export default PasswordRequirements;
